/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerExportTypes.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Export Types
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, December 09, 2019 - 04:11:05 AM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      12/09/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    EXPORTTYPE_LIST_CONTAINER_LOADED,
    EXPORTTYPE_LIST_CONTAINER_UNLOADED,
    EXPORTTYPE_LIST_TABLE_LOADED,
    EXPORTTYPE_LIST_TABLE_UNLOADED,

    EXPORTTYPE_SELECT_ROW,
    EXPORTTYPE_ADD,
    EXPORTTYPE_EDIT,
    EXPORTTYPE_DELETE,
    EXPORTTYPE_OPEN_WARNING,
    EXPORTTYPE_CLOSE_WARNING,
    EXPORTTYPE_DELETE_DISABLE,

    EXPORTTYPE_EDIT_CONTAINER_LOADED,
    EXPORTTYPE_EDIT_CONTAINER_UNLOADED,
    EXPORTTYPE_EDIT_FORM_LOADED,
    EXPORTTYPE_EDIT_FORM_UNLOADED,
    EXPORTTYPE_EDIT_DATA_LOAD,
    EXPORTTYPE_EDIT_CONTAINER_SUBMIT,
    EXPORTTYPE_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeExportTypes';

const defaultState = {
    refreshList: false,
    danger: false,
    exporttypeid: 0,
    name: '',
    description: '',
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case EXPORTTYPE_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                exporttypes: action.payload[0] ? action.payload[0].records : null
            }
        case EXPORTTYPE_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case EXPORTTYPE_SELECT_ROW:
            return {
                ...state,
                exporttypeid: action.id
            }
        case EXPORTTYPE_ADD:
            return {
                ...state
            }
        case EXPORTTYPE_EDIT:
            return {
                ...state,
                exporttypeid: action.id
            }
        case EXPORTTYPE_DELETE:
            return {
                ...state,
                exporttypeid: null
            }
        case EXPORTTYPE_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case EXPORTTYPE_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case EXPORTTYPE_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case EXPORTTYPE_EDIT_CONTAINER_LOADED:
        case EXPORTTYPE_EDIT_DATA_LOAD:
            return {
                ...state,
                exporttypeid: action.payload[0] ? action.payload[0].exporttypeid : 0,
                name: action.payload[0] ? action.payload[0].name : '',
                description: action.payload[0] ? action.payload[0].description : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case EXPORTTYPE_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case EXPORTTYPE_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case EXPORTTYPE_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case EXPORTTYPE_LIST_CONTAINER_UNLOADED:
        case EXPORTTYPE_LIST_TABLE_UNLOADED:
        case EXPORTTYPE_EDIT_CONTAINER_UNLOADED:
        case EXPORTTYPE_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerExportTypes.js